import { render, staticRenderFns } from "./banksetRussia.vue?vue&type=template&id=01510a7e&scoped=true"
import script from "./banksetRussia.vue?vue&type=script&lang=js"
export * from "./banksetRussia.vue?vue&type=script&lang=js"
import style0 from "./banksetRussia.vue?vue&type=style&index=0&id=01510a7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01510a7e",
  null
  
)

export default component.exports